const styles = require('@/components/Base/base.scss');
import { computed, Ref } from 'vue';
export function getColors(type: Ref<string>) {
  const bgColor = computed(() => styles[type.value + '-color']);
  const activeColor = computed(() => styles[type.value + '-active-color']);
  const innerColor = computed(() => styles[type.value + '-inner-color']);

  return {
    bgColor,
    activeColor,
    innerColor,
  };
}
